import { createProvider } from '@nvision/services/data-provider';
import { normalizeUrgencyCodesList } from '@views/screens/common/data-provider/urgency-codes-list/normalize';

import * as api from './api';

export const fetchUrgencyCodesList = createProvider(api.fetchUrgencyCodesList)
  .andThen((res) => normalizeUrgencyCodesList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
